// extracted by mini-css-extract-plugin
module.exports = {"button":"balance-button_button__7P97s","icon":"balance-button_icon__QK2oZ"};